var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.extra.sideHelp)?_c('div',{staticClass:"title postScriptum",attrs:{"id":"help-box"}},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.$route.meta.extra.sideHelp.text))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }